import axios from "axios";

const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const DispatchService = {
    list: async (filters = {}) =>
        axios.post(`${API_DESPACHO}/dispatch/list`, filters).then(({data}) => data.data).catch((err) => { throw err }),

    formData: async ({id, retroactive}) => {
        const url = retroactive ? `${API_DESPACHO}/dispatch/retroactive` : `${API_DESPACHO}/dispatch/${id}`;
        return axios.get(url).then(({data}) => data).catch((err) => { throw err });
    },

    getDispatchMyGarrison: async (garrisonId) =>
        axios.get(`${API_DESPACHO}/dispatch/mygarrison?garrisonId=${garrisonId}`).then(({data}) => data).catch((err) => { throw err }),

    getGarrisonVehicle: async (garrisonId) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId);
        return axios.post(`${API_DESPACHO}/dispatch/getGarrisonVehicle`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    getDispatchByAttendanceId: async (attendanceId) => {
        const formData = new FormData();
        formData.append("attendanceId", attendanceId);
        return axios.post(`${API_DESPACHO}/dispatch/getDispatchByAttendance/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    getGarrisonBySetDispatch: async (garrisonId, supportForGarrisonId = null, isActivity = false) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId);
        formData.append("supportForGarrisonId", supportForGarrisonId ?? "");
        formData.append("isActivity", isActivity);
        return axios.post(`${API_DESPACHO}/dispatch/getGarrisonBySetDispatch/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    getGarrisonBySetDispatchSupports: async (garrisonId) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId);
        return axios.post(`${API_DESPACHO}/dispatch/getGarrisonBySetDispatchSupports/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    getGarrisonBySetDispatchFill: async (garrisonId) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId);
        return axios.post(`${API_DESPACHO}/dispatch/getGarrisonBySetDispatchFill/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    getGarrisonNearby: async (attendanceId) => {
        const formData = new FormData();
        formData.append("attendanceId", attendanceId);
        return axios.post(`${API_DESPACHO}/garrison/getGarrisonNearby`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    getDispatchByGarrisonIdToView: async (garrisonId) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId);
        return axios.post(`${API_DESPACHO}/dispatch/getDispatchByGarrisonIdtoView/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    getClosedDispatch: async (garrisonId) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId);
        return axios.post(`${API_DESPACHO}/dispatch/getClosedDispatch/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    getGarrisonNameByDispatch: async (dispatchId) => {
        const formData = new FormData();
        formData.append("dispatchId", dispatchId);
        return axios.post(`${API_DESPACHO}/dispatch/getGarrisonNameByDispatch/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    checkMileage: async (garrisonId, actualKm) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId);
        formData.append("actualKm", actualKm ?? "");
        return axios.post(`${API_DESPACHO}/vehicle/checkMileage/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    setDispatch: async ({garrisonId, attendanceId, nature, mileage, dispatchToCloseId, finalObservation, allowViewCall = false}) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId);
        formData.append("attendanceId", attendanceId);
        formData.append("nature", nature ?? "");
        formData.append("mileage", mileage ?? "");
        formData.append("dispatchToCloseId", dispatchToCloseId ?? "");
        formData.append("finalObservation", finalObservation ?? "");
        formData.append("allowViewCall", allowViewCall);
        return axios.post(`${API_DESPACHO}/dispatch/setDispatch/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    setDispatchBySupport: async ({garrisonId, mileage, garrisonSupportId, dispatchToCloseId, finalObservation}) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId);
        formData.append("mileage", mileage ?? "");
        formData.append("garrisonSupportId", garrisonSupportId);
        formData.append("dispatchToCloseId", dispatchToCloseId ?? "");
        formData.append("finalObservation", finalObservation ?? "");
        return axios.post(`${API_DESPACHO}/dispatch/setDispatchBySupport/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    setDispatchByFill: async ({garrisonId, nature, garrisonBySupervision, dispatchToCloseId, finalObservation, dispatchToCloseAttendanceId}) => {
        const formData = new FormData();
        formData.append("garrisonId", garrisonId);
        formData.append("nature", nature ?? "");
        formData.append("garrisonBySupervision", garrisonBySupervision ?? "");
        formData.append("dispatchToCloseId", dispatchToCloseId ?? "");
        formData.append("finalObservation", finalObservation ?? "");
        formData.append("dispatchToCloseAttendanceId", dispatchToCloseAttendanceId ?? "");
        return axios.post(`${API_DESPACHO}/dispatch/setDispatchByFill/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    fillDispatch: async (payload) =>
        axios.post(`${API_DESPACHO}/dispatch/fillDispatch/`, payload).then(({data}) => data).catch((err) => { throw err }),

    changeOwner: async (payload) =>
        axios.post(`${API_DESPACHO}/dispatch/setChangeOwner/`, payload).then(({data}) => data).catch((err) => { throw err }),

    getSupportsDispatchByChangeOwner: async (supportId) => {
        const formData = new FormData();
        formData.append("supportId", supportId);
        return axios.post(`${API_DESPACHO}/dispatch/getSupportsDispatchByChangeOwner/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    closeDispatch: async (payload, files = [], withSupport = false) => {
        const formData = new FormData();
        formData.append("dispatchJson", JSON.stringify(payload));
        files.forEach(item => formData.append(item.field, item.file, item.name));
        const endpoint = withSupport ? "setClosedDispatchWithSupport" : "setClosedDispatch";
        return axios.post(`${API_DESPACHO}/dispatch/${endpoint}/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    dispatchAssignment: async ({garrisonId, attendanceId = null, taskId = null}) =>
        axios.post(`${API_DESPACHO}/assignment/`, {garrisonId, attendanceId, taskId}).then(({data}) => data).catch((err) => { throw err }),

    removeAssignmentItem: async (id) =>
        axios.post(`${API_DESPACHO}/assignment/remove/${id}`).then(({data}) => data).catch((err) => { throw err }),

    dispatchGenerateByTask: async ({garrisonId, taskId, dispatchToCloseId, actualKm, finalObservation}) =>
        axios.post(`${API_DESPACHO}/dispatch/setDispatchByTask/`, {
            garrisonId,
            taskId,
            dispatchToCloseId: dispatchToCloseId ?? null,
            actualKm: actualKm === "" ? null : actualKm,
            finalObservation: finalObservation ?? null,
        }).then(({data}) => data).catch((err) => { throw err }),

    dispatchGenerateByAssignment: async ({assignmentId, dispatchToCloseId, actualKm, finalObservation}) =>
        axios.post(`${API_DESPACHO}/dispatch/setDispatchByAssignment/`, {
            assignmentId,
            dispatchToCloseId: dispatchToCloseId ?? null,
            actualKm: actualKm === "" ? null : actualKm,
            finalObservation: finalObservation ?? null,
        }).then(({data}) => data).catch((err) => { throw err }),

    dispatchGenerateByGarrisonSchedule: async ({garrisonId, scheduleId, scheduleItemId, garrisonBySupervision, actualKm, finalObservation, dispatchToCloseId}) =>
        axios.post(`${API_DESPACHO}/dispatch/setDispatchByGarrisonSchedule/`, {
            garrisonId,
            scheduleId,
            scheduleItemId,
            garrisonBySupervision: garrisonBySupervision ?? null,
            dispatchToCloseId: dispatchToCloseId ?? null,
            actualKm: actualKm === "" ? null : actualKm,
            finalObservation: finalObservation ?? null,
        }).then(({data}) => data).catch((err) => { throw err }),

    getGarrisonListByRetroactive: async (dateStartDispatch, dateEndDispatch) => {
        const formData = new FormData();
        formData.append("dateStartDispatch", dateStartDispatch);
        formData.append("dateEndDispatch", dateEndDispatch);
        return axios.post(`${API_DESPACHO}/dispatch/getGarrisonListByRetroactive`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    verifyMileageBeforeUpsert: async (model) =>
        axios.post(`${API_DESPACHO}/dispatch/verifyMileageBeforeUpsert`, model, {headers: {"Content-Type": "application/json"}})
            .then((response) => response).catch((err) => { throw err }),

    upsert: async (id, formData) =>
        axios.post(`${API_DESPACHO}/dispatch/${id || ""}`, formData).then(({data}) => data).catch((err) => { throw err }),

    allAttendances: async (id) => {
        const url = id
            ? `${API_DESPACHO}/attendance/allAttendances/dispatch/${id}`
            : `${API_DESPACHO}/attendance/allAttendances`;
        return axios.get(url).then(({data}) => data).catch((err) => { throw err });
    },

    allAttendancesClosedByLastHours: async () =>
        axios.get(`${API_DESPACHO}/attendance/getAllAttendancesClosedByLastHourst`).then(({data}) => data).catch((err) => { throw err }),

    attendanceById: async (id) => {
        const formData = new FormData();
        formData.append("id", parseInt(id));
        return axios.post(`${API_DESPACHO}/attendance/attendanceById`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    attendanceSelected: async (id) =>
        axios.get(`${API_DESPACHO}/attendance/attendanceSelected/${id}`).then(({data}) => data).catch((err) => { throw err }),

    getClosedDispatchRefuelling: async (dispatchId, garrisonId) => {
        const formData = new FormData();
        formData.append("dispatchId", dispatchId ?? null);
        formData.append("garrisonId", garrisonId);
        return axios.post(`${API_DESPACHO}/dispatch/getClosedDispatchRefuelling`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    getClosedDispatchMaintenance: async (dispatchId, garrisonId) => {
        const formData = new FormData();
        formData.append("dispatchId", dispatchId ?? null);
        formData.append("garrisonId", garrisonId);
        return axios.post(`${API_DESPACHO}/dispatch/getClosedDispatchMaintenance`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    generateNumberBo: async (dispatchId) => {
        const formData = new FormData();
        formData.append("dispatchId", dispatchId);
        return axios.post(`${API_DESPACHO}/dispatch/generateNumberBo`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    getAllPointsCamera: async () =>
        axios.get(`${API_DESPACHO}/dispatch/getAllPointsCamera`).then(({data}) => data).catch((err) => { throw err }),

    getAttendancesByImageReservation: async (dispatchStart) =>
        axios.get(`${API_DESPACHO}/attendance/getByImageReservation`, {params: {dispatchStart}}).then(({data}) => data).catch((err) => { throw err }),

    getDateFormattedView: async () =>
        axios.get(`${API_DESPACHO}/configuration/getDateFormattedView`).then(({data}) => data).catch((err) => { throw err }),

    getShouldShowMessageForUnuploadedBo: async (id) =>
        axios.get(`${API_DESPACHO}/dispatch/getShouldShowMessageForUnuploadedBo/${id}`).then(({data}) => data).catch(() => null),

    individualCortexSearch: async (cpf) =>
        axios.get(`${API_KEEPER}/cortex/personDataByCpf/${cpf}`).then(({data}) => data).catch((err) => { throw err }),
};

export default DispatchService;
